import PropTypes from "prop-types";

import Hero from "components/shared/hero/Hero";
import Title from "components/shared/hero/title/Title";

import {
    Background,
    Text,
    Stats,
    Stat,
    Number,
    Label
} from "./AboutHero.styled";

function AboutHero({ breadcrumbsItems }) {
    return (
        <Hero
            breadcrumbs={breadcrumbsItems}
            contentWidth="half"
            background={<Background />}
        >
            <Title>Over ons</Title>
            <Text>
                <strong>
                    Lees! Cadeau: dé cadeaukaart om letterlijk te verrassen.
                </strong>
                <br />
                Ons doel is om ervoor te zorgen dat jij degene die jij wil
                verwennen, een persoonlijk cadeau kan geven. De ontvanger kan de
                cadeaukaart namelijk bij onze acceptanten inwisselen voor
                bijvoorbeeld een romantisch verhaal, een hip tijdschrift of een
                spannend e-book!
            </Text>
            <Stats>
                <Stat>
                    <Number>40+</Number>
                    <Label>Werknemers</Label>
                </Stat>
                <Stat>
                    <Number>450.000+</Number>
                    <Label>Boeken, e-books en tijdschriften</Label>
                </Stat>
                <Stat>
                    <Number>1000+</Number>
                    <Label>Acceptanten</Label>
                </Stat>
                <Stat>
                    <Number>100+</Number>
                    <Label>Manieren om te verrassen</Label>
                </Stat>
            </Stats>
        </Hero>
    );
}

AboutHero.propTypes = {
    breadcrumbsItems: PropTypes.array
};

AboutHero.defaultProps = {
    breadcrumbsItems: [
        {
            title: "Over ons",
            url: "/over-ons"
        }
    ]
};

export default AboutHero;
